import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import css from "flatpickr/dist/flatpickr.min.css"

export default class extends Controller {
  static values = { time: Boolean, noDate: Boolean };

  connect() {
    let modal = this.element.closest("div.modal");

    this.flatpickr = flatpickr(this.element, {
      enableTime: this.timeValue || false,
      noCalendar: this.noDateValue || false,
      // these fix a bug in flatpickr when used inside bootstrap 4 modal
      onOpen: function(selectedDates, dateStr, instance){
        if (modal) modal.removeAttribute('tabindex');
      },
      onClose: function(selectedDates, dateStr, instance){
        if (modal) modal.setAttribute('tabindex', -1);
      }
    });
  }

  disconnect() {
    this.flatpickr.destroy();
  }
}
